import { useState } from 'react'
import { VStack } from '@musinsa/mwms-ds'
import { PageLayout } from '@/components/layout/PageLayout'
import TitleSection from '@/components/content/TitleSection'
import { Tabs } from '@/components/content/Tabs/Tabs'
import { BasePriceTab } from './components/basePrice/BasePriceTab'
import { CategoryPriceTab } from './components/category/CategoryPriceTab'
import { PRICING_TAB, PricingTabValue } from './consts'
import { PricingTableStyle } from './components/pricingGridStyle'

function SettlementPricing() {
  const [tab, setTab] = useState<PricingTabValue>(PRICING_TAB.CATEGORY)

  return (
    <PageLayout gap={16}>
      <PricingTableStyle />
      <VStack gap={12}>
        <TitleSection title="MFS 단가관리" />
        <Tabs className="pricing-tabs" value={tab} onTabChange={setTab}>
          <Tabs.Item label="카테고리 단가" value={PRICING_TAB.CATEGORY} />
          <Tabs.Item label="기본단가" value={PRICING_TAB.BASE} />
        </Tabs>
      </VStack>
      {tab === PRICING_TAB.BASE ? <BasePriceTab /> : <CategoryPriceTab />}
    </PageLayout>
  )
}

export default SettlementPricing
